/** Shared motion tokens. Prefer these over `transition: all`. */

export const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)'
export const DURATION_PRESS = '120ms'
export const DURATION_UI = '160ms'

export const TRANSITION_PRESS =
  `transform ${DURATION_PRESS} ${EASE_OUT}, opacity ${DURATION_PRESS} ${EASE_OUT}`

export const TRANSITION_UI =
  `transform ${DURATION_UI} ${EASE_OUT}, opacity ${DURATION_UI} ${EASE_OUT}, background-color 160ms ease, color 160ms ease, border-color 160ms ease, box-shadow 160ms ease`
